var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSebAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M48.8559,16c3-2,4-5,3-9c7,2,6,10,3,15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M23.1441,16c-3-2-4-5-3-9c-7,2-6,10-3,15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA5A47",
    d: "M36,13c-12.6823,0-23,10.3177-23,23s10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3176,48.6822,13,36,13z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,32.9252c0,1.6567-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6553,1.3447-3,3-3C28.6552,29.9252,30,31.27,30,32.9252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,32.9252c0,1.6567-1.3447,3-3,3s-3-1.3433-3-3c0-1.6553,1.3447-3,3-3S48,31.27,48,32.9252"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    x2: 30,
    y1: 25,
    y2: 29,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49,
    x2: 42,
    y1: 25,
    y2: 29,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M48.8559,16c3-2,4-5,3-9c7,2,6,10,3,15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.1441,16c-3-2-4-5-3-9c-7,2-6,10-3,15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.5,44c1.2841-0.6376,3.9847-1.0308,6.8421-0.9981c2.6235,0.03,4.9897,0.4146,6.1579,0.9981"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSebAngry);
export default __webpack_public_path__ + "static/media/seb-angry.e0646888f7fbeaac37db5c0b72dc548d.svg";
export { ForwardRef as ReactComponent };